import React from "react";
import KolefnisutreikningurPage from "@components/Pages/KolefnisutreikningurPage/KolefnisutreikningurPage";

export default function Software() {
    return <KolefnisutreikningurPage />;
}

export async function getStaticProps({ locale }) {
    return {
        props: {
            messages: (await import(`../locales/${locale}.json`)).default,
        },
    };
}
